import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { IProjectMapLayer } from './IProjectMapLayer'
import { ProjectMapLayerFileType, ProjectMapLayerRenderer } from './types'

export class ProjectMapLayer extends Entity<IProjectMapLayer> {
  id: number | string // It can be string client-side only when the layer is not saved yet in the database.
  name: string
  visible: boolean
  type: ProjectMapLayerFileType
  renderer?: ProjectMapLayerRenderer

  uploadFileUrl?: string
  uploadGeoJsonUrl?: string

  fileDownloadUrl?: string
  geoJsonDownloadUrl?: string

  // Mapbox-hosted vector tileset delivery. `tilesetSourceLayer` is the
  // tileset's vector layer name (required by the Mapbox style spec to render
  // from a vector source) and `tilesetCenterLat` its centre latitude (used to
  // size DXF text at true ground scale) — both known when the tileset is
  // published, so clients never have to fetch TileJSON at runtime.
  tilesetId?: string
  tilesetSourceLayer?: string
  tilesetCenterLat?: number

  localGeoJSON?: GeoJSON.FeatureCollection

  public static new(payload: unknown): ProjectMapLayer {
    const entity = plainToInstance(ProjectMapLayer, payload)

    return entity
  }
}
